export default __webpack_public_path__ + "static/media/notification.8a45102a.png";